<div class="flex flex-col">
    <div #mapElement class="h-[320px] w-full rounded-lg"></div>

    <div class="flex flex-col py-1 mt-2.5 mb-2.5 w-full text-center gap-2">
        <div class="flex justify-center items-center gap-8">
            <div class="flex flex-col items-center min-w-[120px]">
                <div class="text-[1rem] leading-[1.1] opacity-80">Latitude</div>
                <div class="text-[1rem] font-semibold leading-[1.2] mt-1">
                    {{
                        latitude !== null
                            ? this.formatCoordinate(latitude)
                            : '—'
                    }}
                </div>
            </div>

            <div class="flex flex-col items-center min-w-[120px]">
                <div class="text-[1rem] leading-[1.1] opacity-80">
                    Longitude
                </div>
                <div class="text-[1rem] font-semibold leading-[1.2] mt-1">
                    {{
                        longitude !== null
                            ? this.formatCoordinate(longitude)
                            : '—'
                    }}
                </div>
            </div>
        </div>

        <button
            mat-stroked-button
            type="button"
            (click)="useMyLocation()"
            class="w-full"
        >
            <mat-icon>my_location</mat-icon>
            Use my location
        </button>
        @if (locationError) {
            <mat-error>{{ locationError }}</mat-error>
        }
    </div>

    <div class="border-2 border-gray-300 rounded w-full">
        <gmp-place-autocomplete
            #autoCompleteDropdownElement
            class="w-full"
            style="color-scheme: light"
        ></gmp-place-autocomplete>
    </div>
</div>
